/**
 * Les six familles d'arômes, et les descripteurs d'origine.
 *
 * ATTENTION — depuis que le référentiel vit en base, **cette liste ne fait plus autorité**.
 * Elle a servi à peupler la table `reference_term` à la migration, et n'est plus consultée
 * pour valider quoi que ce soit : un descripteur ajouté en séance n'y figure pas, et c'est
 * précisément l'objet du référentiel. Interroger `GET /reference?kind=AROMA`.
 *
 * Ce qui reste vrai ici, et qui compte : **les six familles**. La roue de l'écran 14 a six
 * secteurs de soixante degrés ; leur nombre est une contrainte de dessin autant que de
 * données, et le domaine refuse une septième famille.
 */
export const AROMA_FAMILIES = {
    Végétal: ['Canne fraîche', 'Herbacé', 'Olive', 'Foin'],
    Fruité: ['Banane flambée', 'Fruits cuits', 'Agrumes', 'Fruits exotiques', 'Fruits secs'],
    Épicé: ['Poivre', 'Cannelle', 'Muscade', 'Gingembre'],
    Boisé: ['Boisé', 'Vanille', 'Cuir', 'Tabac', 'Rancio'],
    Torréfié: ['Cacao', 'Torréfié', 'Café', 'Caramel'],
    Technique: ['Vernis', 'Solvant', 'Salin', 'Fumé'],
};
/**
 * Les descripteurs d'amorçage, à plat.
 *
 * Conservé pour la reprise de données et les tests, jamais pour valider une note : la
 * vérité est en base. `isAromaTag` a été retiré — il laissait croire à une autorité que
 * cette liste n'a plus.
 */
export const SEED_AROMA_TAGS = Object.values(AROMA_FAMILIES).flat();
/** Nombre maximum de descripteurs par note — au-delà, la note ne décrit plus rien. */
export const MAX_AROMA_TAGS = 8;
//# sourceMappingURL=aroma-tags.js.map